<riv-icon [name]="'AlertCircle'" [size]="16"></riv-icon>
<ng-content></ng-content>
